// extracted by mini-css-extract-plugin
export default {"tourMinimumAbandonTimeLabel":"styles-module__bIJSR","tourMinimumAbandonTimeInput":"styles-module__pRk4U"};